import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/business-plans",
  component: RouteComponent,
  children: [
    {
      path: "",
      name: "business-plans.index",
      component: () =>
        import(
          /* webpackChunkName: "business-plans" */ "@/views/BusinessPlans/BusinessPlansView.vue"
        ),
      props: true,
      meta: {
        title: "business-plan-list",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "create",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "business-plans.create",
          component: () =>
            import(
              /* webpackChunkName: "business-plans-create" */ "@/views/BusinessPlans/CreateBusinessPlanView.vue"
            ),
          meta: {
            title: "create-business-plan",
            header: {
              show: true,
              buttons: {
                visualization: {
                  thousands: true,
                  compactOrIndirect: true,
                  difference: false,
                },
              },
            },
            navbar: { show: true },
            footer: { show: true },
            fullScreen: { show: true },
          },
        },
        {
          path: "assisted",
          name: "business-plans.create.assisted",
          component: () =>
            import(
              /* webpackChunkName: "business-plans-create-assisted" */ "@/views/BusinessPlans/EasyModeBusinessPlanCreate.vue"
            ),
          meta: {
            title: "create-business-plan-easy-mode",
            header: {
              show: true,
              buttons: {
                visualization: {
                  thousands: true,
                  compactOrIndirect: false,
                  difference: false,
                },
              },
            },
            navbar: { show: true },
            footer: { show: true },
            fullScreen: { show: true },
            store: {
              keepWorkbook: true,
            },
          },
        },
      ],
    },
    {
      path: ":businessPlanId(\\d+)",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "business-plans.show",
          component: () =>
            import(
              /* webpackChunkName: "business-plans-show" */ "@/views/BusinessPlans/BusinessPlanView.vue"
            ),
          props: true,
          meta: {
            title: "business-plan",
            header: {
              show: true,
              buttons: {
                visualization: {
                  thousands: true,
                  compactOrIndirect: true,
                  difference: false,
                },
              },
            },
            navbar: { show: true },
            footer: { show: true },
            fullScreen: { show: true },
          },
        },
        {
          path: "edit",
          name: "business-plans.edit",
          component: () =>
            import(
              /* webpackChunkName: "business-plans-edit" */ "@/views/BusinessPlans/EditBusinessPlanView.vue"
            ),
          props: true,
          meta: {
            title: "edit-business-plan",
            header: {
              show: true,
              buttons: {
                visualization: {
                  thousands: true,
                  compactOrIndirect: true,
                  difference: false,
                },
              },
            },
            navbar: { show: true },
            footer: { show: true },
            fullScreen: { show: true },
          },
        },
        {
          path: "scenarios",
          component: RouteComponent,
          children: [
            {
              path: "create",
              name: "business-plans.scenarios.create",
              component: () =>
                import(
                  /* webpackChunkName: "business-plans-scenarios-create" */ "@/views/Scenarios/ScenarioCreate.vue"
                ),
              props: true,
              meta: {
                title: "scenario-create",
                header: {
                  show: true,
                  buttons: {
                    visualization: {
                      thousands: true,
                      compactOrIndirect: false,
                      difference: true,
                    },
                  },
                },
                navbar: { show: true },
                footer: { show: true },
                fullScreen: { show: true },
                store: {
                  keepWorkbook: true,
                },
              },
            },
            {
              path: ":scenarioId(\\d+)",
              name: "business-plans.scenarios.show",
              component: () =>
                import(
                  /* webpackChunkName: "business-plans-scenarios-show" */ "@/views/Scenarios/ScenarioView.vue"
                ),
              props: true,
              meta: {
                title: "scenario",
                header: {
                  show: true,
                  buttons: {
                    visualization: {
                      thousands: true,
                      compactOrIndirect: true,
                      difference: true,
                    },
                  },
                },
                navbar: { show: true },
                footer: { show: true },
                fullScreen: { show: true },
              },
            },
          ],
        },
      ],
    },
  ],
};
